import { Stack } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

import { Item } from './Item';

export default function Stamps() {
  const stamps = useProductStore((store) => store.product.stamps);

  if (!stamps.length) {
    return null;
  }

  return (
    <Stack direction="column" data-testid="stamps">
      {stamps.map((stamp, index) => (
        <Item
          key={index}
          title={stamp.title}
          src={stamp.img}
          testId={`stamp-${index}`}
        />
      ))}
    </Stack>
  );
}
